import { render, staticRenderFns } from "./CurrencyIcon.vue?vue&type=template&id=7fd819d3&scoped=true&"
import script from "./CurrencyIcon.vue?vue&type=script&lang=js&"
export * from "./CurrencyIcon.vue?vue&type=script&lang=js&"
import style0 from "./CurrencyIcon.vue?vue&type=style&index=0&id=7fd819d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd819d3",
  null
  
)

component.options.__file = "CurrencyIcon.vue"
export default component.exports